import {
  Directive,
  HostBinding,
  Input,
  OnInit,
  OnChanges,
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  ViewContainerRef,
  ComponentFactoryResolver,
  SimpleChanges
} from '@angular/core';
import { Loading } from '../loading/loading.module';

@Directive({
  selector: '[sukaButton]'
})
export class Button implements OnInit, AfterViewInit, OnChanges {
  @Input() sukaButton: 'primary' | 'basic' | 'plain' | 'destructive' | 'outline_white' = 'basic';
  @Input() size: 'md' | 'sm' | 'lg' = 'md';

  @Input() class = '';

  @HostBinding('attr.class') get attrClass() {
    return `btn--${this.sukaButton ? this.sukaButton : 'basic'} ${this.class}`;
  }

  @HostBinding('class.skeleton') @Input() skeleton = false;
  @HostBinding('class.btn--outline') @Input() outline = false;
  @HostBinding('class.btn--hover') @Input() hover = false;
  @HostBinding('class.btn--full_width') @Input() fullWidth = false;
  @HostBinding('class.btn--group_item') @Input() inGroup = false;
  @HostBinding('class.btn--loading') @Input() loading = false;

  @HostBinding('class.btn--sm') get buttonSmall() {
    return this.size === 'sm';
  }
  @HostBinding('class.btn--lg') get buttonLarge() {
    return this.size === 'lg';
  }

  originalInnerText: string;
  loadingSpinner: Loading;

  constructor(
    private ref: ChangeDetectorRef,
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  public ngOnInit() {
    // Create the spinner
    const factory = this.componentFactoryResolver.resolveComponentFactory(Loading);
    const componentRef = this.viewContainerRef.createComponent(factory);
    this.loadingSpinner = componentRef.instance;

    this.loadingSpinner.size = 'sm';

    this.renderer.setStyle(this.loadingSpinner.elementRef.nativeElement, 'display', 'none');

    this.renderer.appendChild(this.el.nativeElement, this.loadingSpinner.elementRef.nativeElement);

    if (this.loading) {
      this.renderer.setStyle(this.loadingSpinner.elementRef.nativeElement, 'display', 'inherit');
      this.el.nativeElement.disabled = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.loadingSpinner) {
      if (this.loading) {
        this.renderer.setStyle(this.loadingSpinner.elementRef.nativeElement, 'display', 'inherit');
      } else {
        this.renderer.setStyle(this.loadingSpinner.elementRef.nativeElement, 'display', 'none');
      }

      this.el.nativeElement.disabled = changes.loading.currentValue;
    }
  }

  ngAfterViewInit() {
    this.ref.detectChanges();
  }
}
